<!-- <p>payment-successful-page works!</p> -->
<div class="bg">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div >
                    <!-- <p class="login-line" >You have been verified successfully</p> -->
                    <p class="login-line" >{{verifyMessage}}</p>
                    <div>
                    <a class="login-sublink" [routerLink]="['/login']">{{Login}}</a>
                </div>
                </div>
            </div>
        </div>
    </div>
</div>

